/** basic.exportRecords */
export default {
    export_state: "Статус данных",
    export_exportMidWay: "Экспортируется",
    export_exportSucc: "Экспорт выполнен",
    export_exportLose: "Экспорт не выполнен",
    export_downloadTips: "Скачать эти данные?",
    export_downloadBtn: "Скачать",
    export_deleteTips: "Удалить эти данные?",
    export_name: "Название данных",
    floorTitle: "План этажа",
}

